export default [
     {
          id: 1,
          serviceDesc:"24HRS Consultation",
          serviceContent:"Take care of your pet,never leave them sick and weak .we are here to help you treat your pets .",
          serviceImage:"../images/vector2.png" ,

     },
     {
          id: 2,
          serviceDesc:"Effective health care",
          serviceContent:"Take care of your pet,never leave them sick and weak .we are here to help you treat your pets .",
          serviceImage:"../images/vector1.png" ,


     },
     {
          id: 3,
          serviceDesc:"Affordable  healthcare",
          serviceContent:"Take care of your pet,never leave them sick and weak .we are here to help you treat your pets .",
          serviceImage:"../images/vector3.png",
     }
]